<template>
  <div class="bg-gradient-lighter min-vh-100">
    <!-- Header -->
    <div class="header bg-gradient-orange py-7 py-lg-8 pt-lg-9">
      <div class="container">
        <div class="header-body text-center mb-7">
          <div class="row justify-content-center">
            <div class="col-xl-5 col-lg-6 col-md-8 px-5">
              <h1 class="text-white">Sign In!</h1>
              <p class="text-lead text-white">
                Sign into your ChinesePod account.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg
          x="0"
          y="0"
          viewBox="0 0 2560 100"
          preserveAspectRatio="none"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <polygon
            class="fill-default"
            points="2560 0 2560 100 0 100"
          ></polygon>
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <div class="container mt--9 pb-5">
      <div class="row justify-content-center">
        <div class="col-lg-5 col-md-7">
          <div class="card bg-secondary border-0 mb-0">
            <div class="card-body px-lg-5 py-lg-5">
              <validation-observer
                v-slot="{ handleSubmit }"
                ref="formValidator"
              >
                <form role="form">
                  <base-input
                    class="mb-3"
                    label="Email"
                    prepend-icon="ni ni-email-83"
                    placeholder="Email"
                    name="email"
                    :rules="{ required: true, email: true }"
                    v-model="model.emailAddress"
                  >
                  </base-input>

                  <base-input
                    class="mb-3"
                    label="Password"
                    prepend-icon="ni ni-lock-circle-open"
                    type="password"
                    name="password"
                    placeholder="Password"
                    :rules="{ required: true }"
                    v-model="model.password"
                  >
                  </base-input>
                  <div v-if="error" class="alert alert-danger">
                    Sorry! Your information doesn't match an existing account.
                    Please check it and try again.
                  </div>
                  <div class="text-center">
                    <base-button
                      type="primary"
                      class="my-2"
                      @click="handleSubmit(handleLogin)"
                      :loading="loading"
                      >Sign in</base-button
                    >
                  </div>
                </form>
              </validation-observer>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-6">
              <a
                href="https://www.chinesepod.com/password/forgot"
                class="text-primary"
              >
                <small>Forgot password?</small>
              </a>
            </div>
            <div class="col-6 text-right">
              <router-link :to="{ name: 'Sign Up' }" class="text-primary">
                <small>Don’t have an account?</small>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'

export default {
  title() {
    return `${this.$route.name} | ChinesePod SchoolZone`
  },
  data() {
    return {
      loading: false,
      error: false,
      model: {
        emailAddress: '',
        password: '',
        clientId: process.env.VUE_APP_TYPE,
        rememberMe: false
      }
    }
  },
  methods: {
    ...mapActions({
      login: 'login'
    }),
    ...mapActions(['getUserInfo']),
    ...mapActions('affiliates', ['getAffiliateInfo']),
    async handleLogin() {
      this.loading = true
      await this.login(this.model)
        .then(async (_) => {
          await this.getAffiliateInfo().catch((_) =>
            console.log('Not an affiliate')
          )
          if (this.$route.params && this.$route.params.continue) {
            await this.$router
              .push(this.$route.params.continue)
              .catch((_) => {})
          } else {
            await this.$router.push({ name: 'Dashboard' }).catch((_) => {})
          }
        })
        .catch((_) => (this.error = true))
      this.loading = false
    }
  }
}
</script>
